export default {
  qflow: {
    title: '简介',
    titleP1_1:`
    Q-Flow主要用于辅助用户使用龙讯第一性原理计算软件
    `,
    titleP1_2:`
    ，它具有良好的图形界面，并且兼具计算、数据存储、数据处理、数据展示等功能，与云平台应用
    `,
    titleP1_3:`
    配合，可以完成从材料建模到性质模拟的一整套流程。目前，Q-Flow v1.0版本已于2022年4月正式登陆
    `,
    titleP1_3a: '龙讯超算云平台',
    titleP1_4:`
    ，已注册用户可以直接点击Q-Flow图标打开应用，开展物理、化学、生物等领域的科研和教学工作。
    `,
    feature1: `
    Q-Flow采用B/S架构，其中计算参数设置、计算流程设置、结果展示等功能部署于浏览器端，模拟计算、数据存储、数据处理等功能部署在服务器端。
    `,
    feature2: `
    Q-Flow在操作上简单、便捷、易上手，拖拽式的组件和模板使用户可以快速完成计算流程设计。交互式图形界面使得计算参数设置准确、可靠、合理，减少用户学习成本，提高计算可靠性和稳定性。
    `,
    feature3: `
    Q-Flow中计算、数据处理、数据存储功能部署在服务器，由PWmat、PWmat顶层模块、作业调度系统、前/后处理程序共同完成。
    用户无需熟悉Linux系统和操作，而是通过浏览器直接访问后端已处理数据，高效、实时地获取计算进度、计算结果和计算生成文件。
    `,
    step1: '通过龙讯超算云平台访问Q-Flow',
    step2: '上传模型到私人结构库',
    step3: '快速查看模型',
    step4: '创建项目',
    step5: '创建工作流',
    step6: '设计工作流',
    step7: '设置计算参数',
    step8: '提交作业开始计算',
    step9: '查看计算状态',
    step10: '查看计算结果',

    download: '相关下载',
    download1: 'PWmat下载',
    download2: 'Module下载',
    download3: '手册下载',
    download4: '赝势下载',
    download5: 'Mcloud手册',
  }
}